<sim-basic-material-dialog
	(closeClicked)="close()"
	[finished]="finished"
	[headerIcon]="{fontSet: 'fad', fontIcon: 'fa-shield'}"
	[headerText]="T.HEALTH_DIALOG_SUBTITLE | translate"
	[matDialogData]="data"
	[rect]="rect"
>
	<ng-container dialogContent>
		<div class="healthReportCon">
			@if (componentErrors && componentErrors.length > 0 && !loadingHealthReport) {
				@for (component of componentErrors; track component.serviceType) {
					<h2>{{ ServiceType[component.serviceType] }}</h2>
					<ul class="healthReportMessages">
						@for (errorMessage of component.errorMessages; track errorMessage) {
							<li>
								{{ errorMessage }}
							</li>
						}
					</ul>
				}
				<sim-button
					class="navigateToHealthMonitorBtn"
					[icon]="{fontSet: 'fad', fontIcon: 'fa-shield'}"
					(onClick)="navigateToHealthMonitor()"
					[label]="T.NAVIGATE_TO_HEALTH_MONITOR"
				/>
			}

			<sim-component-loading-container
				[isLoading]="loadingHealthReport"
				[loadingIcon]="'fad fa-shield'"
				[loadingMessage]="T.LOADING_HEALTH_REPORT | translate"
			/>
		</div>
	</ng-container>

	<ng-container actions>
		<sim-button
			(onClick)="close({action: 'cancel'})"
			[color]="'primary'"
			[icon]="{fontSet: 'fad', fontIcon: 'fa-check'}"
			[label]="T.BUTTON_CANCEL"
		/>
	</ng-container>
</sim-basic-material-dialog>
